<template>
  <v-popup v-model="show" :class="bem()" position="right" v-backFn="{ show: show, closeFn: 'close' }">
    <iframe v-if="show" :src="url" frameborder="0" width="100%" height="100%"></iframe>
  </v-popup>
</template>

<script>
import { create } from '../utils'
import { app } from '@/utils'

export default create({
  name: 'sub-page',
  data() {
    return {
      show: false,
      url: ''
    }
  },
  methods: {
    close() {
      this.show = false
    }
  }
})
</script>

<style lang="scss" src="./index.scss"></style>
